"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");
/**
 * Parses object as original object. There are no changes to the original object.
 *
 * @author Tomáš Leity
 */


var CustomObjectParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(CustomObjectParser, _Parser_1$Parser);

  function CustomObjectParser() {
    _classCallCheck(this, CustomObjectParser);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomObjectParser).call(this));
  }

  _createClass(CustomObjectParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (utils_1.Utils.isObject(input)) {
        return parserSupport_1.succ(input);
      }

      return new ValidationResult_1.ValidationError(parserSupport_1.UNSUPPORTED_VALUE_ERROR, null);
    }
  }]);

  return CustomObjectParser;
}(Parser_1.Parser);

exports.CustomObjectParser = CustomObjectParser;